import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HistoriaDeUsuario } from 'src/app/shared/historiaUsuario';
import swal from 'sweetalert2';
import { HucuService } from '../hucu.service';
import { EpicasBean } from 'src/app/shared/model/gestion-proyectos/epicas.model';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { SoloNumeroDirective } from '../../utilerias/directives/solo-numero.directive';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-modal-hu',
    templateUrl: './modal-hu.component.html',
    styleUrls: ['./modal-hu.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, NgFor, MatOption, SoloNumeroDirective, MatButton]
})
export class ModalHuComponent {
  objetoHistoriaUsuario: HistoriaDeUsuario;
  @Input() id_proyecto: number;
  @Input() datosCu: any;
  @Input() dialogRef: MatDialogRef<ModalHuComponent>;
  listaHistoriasUsuario: Array<HistoriaDeUsuario>;
  listEpicas: Array<EpicasBean>;
  historiasUsuarioGroup: FormGroup;

  prioridad = [
    { valor: 1 },
    { valor: 2 },
    { valor: 3 },
    { valor: 4 }
  ];
  riesgo = [
    { nombre: 'Muy Alto', valor: 1 },
    { nombre: 'Alto', valor: 2 },
    { nombre: 'Moderado', valor: 3 },
  ];
  iteracion = [
    { valor: 1 },
    { valor: 2 },
    { valor: 3 },
    { valor: 4 }
  ];

  constructor(private hucuService: HucuService, private formbuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.inicializarFormulario();
    if (this.datosCu != null) {
      this.objetoHistoriaUsuario = this.datosCu;
      this.consultaHistoriasUsuario(this.datosCu.id);
    } else {
      this.objetoHistoriaUsuario = new HistoriaDeUsuario();
    }
    this.consultarEpicasxProyecto();
  }

  inicializarFormulario(){
    this.historiasUsuarioGroup = this.formbuilder.group({
      tituloCtrl: new FormControl( '' , Validators.required),
      descripcionCtrl: new FormControl('', Validators.required),
      comoCtrl: new FormControl('', Validators.required),
      necesitoCtrl: new FormControl('', Validators.required),
      paraCtrl: new FormControl('', Validators.required),
      criteriosAceptacionCtrl: new FormControl('', Validators.required),
      iteracionCtrl: new FormControl('', Validators.required),
      prioridadCtrl: new FormControl('', Validators.required),
      riesgoCtrl: new FormControl('', Validators.required),
      puntosCtrl: new FormControl('', Validators.required),
      epicaCtrl: new  FormControl('', Validators.required),
    });
  }

  consultarEpicasxProyecto() {
    this.hucuService.consultaEpicasxProyecto(this.id_proyecto).subscribe(res => {
      this.listEpicas = res.list;
    });
  }

  guardarHu() {
    this.objetoHistoriaUsuario.id_proyecto = this.id_proyecto;
    this.hucuService.guardarHu(this.objetoHistoriaUsuario).subscribe(
      (respuesta) => {
        swal.fire({
          text: 'Historia de Usuario registrada exitosamente',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          icon: 'success',

        }).then((result) => {
          this.dialogRef.close(true);
        });
      });
  }

  consultaHistoriasUsuario(id: number) {
    this.hucuService.consultaHu(id).subscribe(res => {
      this.listaHistoriasUsuario = res.list;
      if (this.listaHistoriasUsuario.length > 0) {
        this.objetoHistoriaUsuario = this.listaHistoriasUsuario[0];
      }
    });
  }

}
